import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import {
  AllAPIResponses,
  CarbonError,
  AlarmHistoryType,
} from './../../../index';

type PayloadType = {
  endtime?: string;
  nodeId?: number;
  ruleId: number;
  startTime: number;
  uniqueId: string;
};

const post = async (
  payload: PayloadType,
  headers?: Headers
): Promise<AllAPIResponses<AlarmHistoryType>> => {
  try {
    const resp = await req.post(
      '/api/alarms/history',
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as AlarmHistoryType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
